import { UserPermissionCodes } from "@odata/CompanyPermissionEnums";
import { EntityTypeName } from "@odata/GeneratedEntityTypes";
import React, { lazy } from "react";

import { ROUTE_FIXED_ASSET, ROUTE_MINOR_ASSET, ROUTE_UNORGANIZED_ASSET } from "../routes";
import FormRoute from "../routes/FormRoute";

const MinorAsset = lazy(() => import(/* webpackChunkName: "assets" */"../pages/asset/minorAsset/MinorAsset"));
const FixedAsset = lazy(() => import(/* webpackChunkName: "assets" */"../pages/asset/fixedAsset/FixedAsset"));
const UnorganizedAsset = lazy(() => import(/* webpackChunkName: "assets" */"../pages/asset/unorganizedAsset/UnorganizedAsset"));

export default function assetBundle(): React.ReactElement[] {
    return [
        <FormRoute
                path={ROUTE_MINOR_ASSET}
                key={ROUTE_MINOR_ASSET}
                entityType={EntityTypeName.MinorAsset}
                CPs={UserPermissionCodes.Asset}
                page={MinorAsset}/>,

        <FormRoute
                path={ROUTE_FIXED_ASSET}
                key={ROUTE_FIXED_ASSET}
                entityType={EntityTypeName.Asset}
                CPs={UserPermissionCodes.Asset}
                page={FixedAsset}/>,
        <FormRoute
                path={ROUTE_UNORGANIZED_ASSET}
                key={ROUTE_UNORGANIZED_ASSET}
                entityType={EntityTypeName.UnorganizedAsset}
                CPs={UserPermissionCodes.Asset}
                page={UnorganizedAsset}/>
    ];
}